import React from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Grid,
  Box,
  IconButton
} from '@mui/material';
import {
  Photo as PhotoIcon,
  ArrowForward as ArrowIcon
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import logger from '../../../utils/logger';

const PhotoGalleryPreview = ({ photos, loading }) => {
  logger.log('[PhotoGalleryPreview] Received photos:', photos?.length, photos);

  if (loading) {
    return (
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={<PhotoIcon color="primary" />}
          title="Recent Photos"
        />
        <CardContent sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Loading...
          </Typography>
        </CardContent>
      </Card>
    );
  }

  if (!photos || photos.length === 0) {
    return (
      <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <CardHeader
          avatar={<PhotoIcon color="primary" />}
          title="Recent Photos"
          action={
            <IconButton component={Link} to="/photos?tab=family">
              <ArrowIcon />
            </IconButton>
          }
        />
        <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <PhotoIcon sx={{ fontSize: 40, opacity: 0.4 }} />
          <Typography variant="body2" color="text.primary" sx={{ opacity: 0.7, textAlign: 'center' }}>
            No photos yet. Upload your first family photo!
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader
        avatar={<PhotoIcon color="primary" />}
        title="Recent Photos"
        action={
          <IconButton component={Link} to="/photos?tab=family" title="View gallery">
            <ArrowIcon />
          </IconButton>
        }
      />
      <CardContent sx={{ pt: 0 }}>
        <Grid container spacing={1}>
          {photos.slice(0, 6).map((photo) => (
            <Grid item xs={4} key={photo.id}>
              <Box
                sx={{
                  position: 'relative',
                  paddingTop: '100%', // 1:1 aspect ratio
                  borderRadius: 1,
                  overflow: 'hidden',
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8
                  }
                }}
                component={Link}
                to="/photos?tab=family"
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url(${photo.url || photo.photoURL})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
        {photos.length > 6 && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, textAlign: 'center' }}>
            +{photos.length - 6} more photos
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default PhotoGalleryPreview;
